<template>
    <div class="page_title_area">
        APP管理
    </div>
</template>
<script>
import mixins from "./Mixins";
export default {
mixins:[mixins],
mounted(){
    this.setLeftMenuShow_M(true);
    this.setLeftMenuIndex_M(7);
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/PartI/AppManage/components/appTitle.vue